import "./LoadingSpinner.scss";
import React from "react";

export function LoadingSpinnerComponent(props: { isLoading: boolean }) {
    return props.isLoading ? (
        <div className="LoadingSpinnerComponent">
            <div className="load">
                <hr />
                <hr />
                <hr />
                <hr />
            </div>
        </div>
    ) : null;
}
